export default "__VITE_ASSET__7757be94__"